export default function getDatePartValue(
  dateParts: Intl.DateTimeFormatPart[],
  key: string
): string {
  const datePart = dateParts.find((p: Intl.DateTimeFormatPart): boolean => {
    return p.type.toUpperCase() === key.toUpperCase();
  });

  if (datePart) {
    return datePart.value;
  }

  return '';
}
